export default __webpack_public_path__ + "static/media/GoudyBookletter.263668b8.woff2";